import { CalendarMonthOutlined, MapOutlined, TodayOutlined } from '@mui/icons-material'
import { BottomNavigation, BottomNavigationAction, Box, LinearProgress, Paper } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { sizing, useThemeMode } from '../../theme'

export const Footer = () => {
  const translation = useTranslation()
  const { i18n } = translation
  const { footerIndex, loading, footerLinks } = useSelector((state) => state?.navigation)
  const { palette } = useThemeMode()

  const footerContainerStyle = {
    height: `${sizing.footer.height}px`,
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    background: palette.headerColor,
    zIndex: '10'
  }

  const progressStyle = {
    width: '100%',
    position: 'absolute',
    bottom: `${sizing.footer.height + 5}px`
  }

  const bottomNavStyle = {
    background: palette.headerColor,
    height: `${sizing.footer.height}px`,
    '& .MuiBottomNavigationAction-root': {
      minWidth: '56px',
      paddingTop: '4px',
      paddingBottom: '6px'
    },
    '& .MuiBottomNavigationAction-label': {
      fontSize: '0.68rem',
      lineHeight: 1,
      marginTop: '2px'
    },
    '& .MuiBottomNavigationAction-root.Mui-selected': {
      color: palette.paperColor,
      filter: `drop-shadow(0px 0px 3px ${palette.headerBrightColor})`
    },
    '& .MuiBottomNavigationAction-root.disabled': {
      color: palette.errorText,
      filter: 'none'
    },
    '& .MuiBottomNavigationAction-root.Mui-selected.disabled': {
      color: palette.errorText,
      filter: `drop-shadow(0px 0px 3px ${palette.headerBrightColor})`
    }
  }

  const progress = loading ? (<Box sx={progressStyle}><LinearProgress /></Box>) : undefined
  return (
    <Paper data-component="companion-footer" style={footerContainerStyle}>
        {progress}
        <BottomNavigation value={footerIndex} sx={bottomNavStyle} showLabels >
          <BottomNavigationAction label={i18n.t('today')}
            icon={<TodayOutlined fontSize="small" />}
            component={Link}
            to={footerLinks.notifications}
          />

          <BottomNavigationAction
            label={i18n.t('events')}
            icon={<CalendarMonthOutlined fontSize="small" />}
            component={Link}
            to={footerLinks.events}
          />

          <BottomNavigationAction
            label={i18n.t('map')}
            icon={<MapOutlined fontSize="small" />}
            component={Link}
            to={footerLinks.map}
          />
        </BottomNavigation>
      </Paper>
  )
}
